import { COUPON_PRICE_TYPE, COUPON_AGE_TYPE, USED_FORM_DIV } from '@/constants/coupon';

// 型
//* ***********************************************************************************/
export type ChildrenType = {
  childrenType10: number;
  childrenType15: number;
  childrenType20: number;
  childrenType30: number;
  childrenType40: number;
  childrenType50: number;
};

export type PriceListItemType = {
  subsidyPriceId: string;
  subsidyDetailId: string;
  priceType: '本人' | '家族' | '一律';
  limApplicableDateFrom: string;
  limApplicableDateTo: string;
  price: number;
  ageType: '大人' | '子供' | '一律';
  remaining?: number;
  useCnt?: number;
  selectUseCnt?: number;
  relationship?: {
    code: string;
    genderDistinction: unknown;
    groupName: unknown;
    relationshipId: string;
    relationshipLevel: string;
    relationshipName: string;
  };
  relationshipCode?: string;
  priceLabel?: string;
  stayDay?: string;
  discount?: number;
  enabledChangeOptionalCouponCnt?: boolean;
};

export type AvailableDataType = {
  tlementNo?: string;
  subsidyDetailId: string;
  dispSubsidyNm: string;
  subsidyId: string;
  receptionDateFrom: string; // "YYYY-MM-DD"
  receptionDateTo: string; // "YYYY-MM-DD"
  applicableDateFrom: string; // "YYYY-MM-DD"
  applicableDateTo: string; // "YYYY-MM-DD"
  subsidyType: string;
  settlementNo: number | null;
  requestType: string;
  applicableDegreeCnt: number;
  personAccompanyFlg: string;
  minTgtAge?: number | null;
  usedFormDiv: '01' | '02';
  usedLimTerm: string;
  usedLimUnit: string;
  usedMaxCnt: number | null;
  usedMaxTotalAmt: number | null;
  parsonalUsedMaxCnt: number | null;
  parsonalUsedMaxTotalAmt: number | null;
  usedExpectedAmt: number | null;
  yearEndDatetime: string; // "YYYY-MM-DD"
  useStopFlg: string;
  subsidySts: string;
  requestDate: string; // "YYYY-MM-DD"
  requestUserId: string;
  approvalDate: string | null; // "YYYY-MM-DD"
  approvalUserId: string | null;
  minChargeAmt?: number | null;
  costUnderChargeableFlg: string;
  fiveDaysAgoControlFlg: string;
  dispMyPage: string;
  dispNoteComment: string;
  priceList: PriceListItemType[];
  couponInfo?: {
    subsidyDetailId: string;
    couponId: string;
    customerNo: string;
    getDate: string;
    usedFlag: string;
    parsonalAssignmentCnt: number;
  }[];
  subsidyClass: string;
  multipleUnusableFlg: string;
  targetService: string;
  auxiliaryType: string;
  groupInfo: {
    groupId: string;
    groupName: string;
    dispWebNm: string;
    payOffFrom: string | null;
    payOffTgtSubscriptionId: number | null;
    targetService: string;
    settingMethodDivCompany: string;
    subsidyType: string;
    receptionDateFrom: string;
    receptionDateTo: string;
    applicableDateFrom: string;
    applicableDateTo: string;
    settlementNo: string;
    usedIimTerm: string | null;
    usedIimUnit: string | null;
    usedMaxCnt: number | null;
    usedMaxTotalAmt: number | null;
    parsonalUsedMaxCnt: number;
    parsonalUsedMaxTotalAmt: number | null;
    usedExpectedAmt: number | null;
    yearEndDatetime: string | null;
    termType: string;
    dispMyPage: string;
    dispNoteComment: string;
  };
};

export type ScrennDisplayItemListType = {
  ageType?: {
    ageTypeName: string;
    ageTypeValue: string;
  }[];
  nameLabel: {
    value: string | null;
    isVisiable: string;
  };
  seiInput: {
    isVIsiable: string | null;
  };
  meiInput: {
    isVisiable: string;
  };
  relationshipLabel: {
    value: string;
    isVisiable: string;
  };
  relationshipPd: {
    relationshipPatternCd: string;
    valueList: string[];
    isVisable: string | null;
  };
  ageLabel: {
    value: string | null;
    isVisiable: string;
  };
  ageInput: {
    isVisiable: string;
  };
  pricetypeLabel: {
    value: string;
    isVisable?: string | null;
  };
  isVisable?: string | null;
  pricetypePd: {
    valueList: string[];
    isVisable: string | null;
  };
  agetypeLabel: {
    value: string;
    isVisable: string | null;
  };
  agetypePd: {
    valueList: string[];
    isVisiable: string;
  };
  subsidyNameLabel?: {
    value: string;
  } | null;
  applicableDateFromLabel?: {
    value: string;
  } | null;
  applicableDateToLabel?: {
    value: string;
  } | null;
  receptionDateFromLabel?: {
    value: string;
  } | null;
  receptionDateToLabel?: {
    value: string;
  } | null;
  priceList?:
    | {
        priceType: string;
        ageType: string;
        value: string;
      }[]
    | null;
  remainingCountLabel: {
    value?: string | null;
  } | null;
  remainingAmountLabel: {
    value?: string | null;
  } | null;
  groupRemainingCountLabel?: {
    value?: string | null;
  } | null;
  groupRemainingAmountLabel?: {
    value?: string | null;
  } | null;
  applicableDegreeCntLabel?: {
    value: string | null;
  } | null;
  personAccompanyNecessityLabel?: {
    value: string | null;
  } | null;
  tgtAgeLabel?: {
    value: string | null;
  } | null;
  costUnderChargeableNecessityLabel?: {
    value: string | null;
  } | null;
  multipleUnusableNecessityLabel?: {
    value: string | null;
  } | null;
};

export type SubsidyAvailableDataListType = {
  availableData: AvailableDataType;
  remainingCount?: number | null;
  availableRemainingCount?: number | null;
  remainingAmount?: number | null;
  availableRemainingAmount?: number | null;
  scrennDisplayItemList: ScrennDisplayItemListType;
  applyPrice?: PriceListItemType;
  price?: number;
  appliedAmt?: number;
  useCnt?: number;
};

export type SubsidyType = {
  availableDataList?: SubsidyAvailableDataListType[];
  scrennDisplayItemList?: ScrennDisplayItemListType;
  useDate?: string;
  nightCntTotal?: number;
  subTotal?: number;
  subsidyAmountTotal?: number;
  billingAmount?: number;
  doneApplyCafe?: boolean;
  cafeUsePoint?: number;
  benepoUseFlag?: string;
  benepoAmountTotal?: number;
  headCntTotal?: number;
  chldSubTotalPp?: string;
  adultsSubTotalPp?: string;
  memberAdults?: number;
  memberChldDetails?: {
    childrenType10: number;
    childrenType15: number;
    childrenType20: number;
    childrenType30: number;
    childrenType40: number;
    childrenType50: number;
  };
  couponApplicable?: {
    couponApplicableNo: string;
    lastName: string;
    firstName: string;
    relationship: string;
    degreeCount: string;
    age: number | null;
    ageType: '大人' | '子供' | '一律';
  }[];
  subsidyReservations?: {
    subsidyId: string;
    subsidyDetailId: string;
    relationship: string;
    degreeCount: string;
    ageType: '大人' | '子供' | '一律';
    priceType: '本人' | '家族' | '一律';
    useDates: {
      useScheduleDateTime: string;
      price: number;
      subsidyPriceId: string;
    }[];
    groupId: string;
    amount: number;
  }[];
};

// [ISOL_TODO] 正確な形式は不明
export type StayNightDetailType = {
  stayDay: string; // "YYYY-MM-DD"
  rooms: [
    {
      stayDays: {
        stayDay: string;
        childTypePrice: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
          visitorType10: number;
          visitorType15: number;
          visitorType20: number;
          visitorType30: number;
          visitorType40: number;
          visitorType50: number;
        };
        roomPrice: number;
        price: number;
        adultPrice: number;
        boneSubsidy: number;
        stock: number;
        reservationDiv: string;
        childrenPriceTable: { childDiv: string; childPrice: number; price: number; boneSubsidy: number }[];
        memberAdultCnt: number;
        memberAdultPrice: number;
        memberAdultChrg: number;
        visitorAdultCnt: number;
        visitorAdultPrice: number;
        visitorAdultChrg: number;
        memberChldCnt: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
        };
        memberChldPrice: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
        };
        memberChldChrg: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
        };
        totalMemberChldCnt: number;
        totalMemberChldChrg: number;
        visitorChldCnt: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
        };
        visitorChldPrice: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
        };
        visitorChldChrg: {
          childrenType10: number;
          childrenType15: number;
          childrenType20: number;
          childrenType30: number;
          childrenType40: number;
          childrenType50: number;
        };
        totalVisitorChldCnt: number;
        totalVisitorChldChrg: number;
      }[];
      member: { man: number; woman: number };
      visitors: { man: number; woman: number };
      memberChildren: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      visitorChildren: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      adultCount: number;
      childrenCount: number;
      roomNo: number;
      roomAmount: number;
      chldaManHeadCnt: number;
      chldaWomanHeadCnt: number;
      relationships: {
        id: number;
        label: string;
        value: string;
        firstName: string;
        lastName: string;
        isMember: boolean;
        isVisitor: boolean;
        isChildren: boolean;
        chldType: 'childrenType10' | '';
        stayDay: unknown;
        roomNo: unknown;
        price: number;
        discount: number;
        subsidyPrice: number;
        relationshipCode: string;
        age: number | '';
        appliedCoupons: SubsidyAvailableDataListType[];
        priceList?: {
          [key: string]: {
            subsidyPriceId: string;
            subsidyDetailId: string;
            priceType: string;
            limApplicableDateFrom: string;
            limApplicableDateTo: string;
            price: number;
            ageType: string;
            discount: number;
          };
        };
        relationship: {
          code: 'C';
          groupName: null;
          relationshipId: string; // "0"
          relationshipName: string;
          relationshipLevel: string; // "0"
          genderDistinction: null;
        };
      }[];
      stayDay: string;
      childTypePrice: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
        visitorType10: number;
        visitorType15: number;
        visitorType20: number;
        visitorType30: number;
        visitorType40: number;
        visitorType50: number;
      };
      roomPrice: number;
      price: number;
      adultPrice: number;
      boneSubsidy: number;
      stock: number;
      reservationDiv: string;
      childrenPriceTable: { childDiv: string; childPrice: number; price: number; boneSubsidy: number }[];
      memberAdultCnt: number;
      memberAdultPrice: number;
      memberAdultChrg: number;
      visitorAdultCnt: number;
      visitorAdultPrice: number;
      visitorAdultChrg: number;
      memberChldCnt: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      memberChldPrice: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      memberChldChrg: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      totalMemberChldCnt: number;
      totalMemberChldChrg: number;
      visitorChldCnt: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      visitorChldPrice: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      visitorChldChrg: {
        childrenType10: number;
        childrenType15: number;
        childrenType20: number;
        childrenType30: number;
        childrenType40: number;
        childrenType50: number;
      };
      totalVisitorChldCnt: number;
      totalVisitorChldChrg: number;
    }
  ];
  coupons: SubsidyAvailableDataListType[];
  expended?: boolean;
};

export type StayDayType = {
  stayDay: string; // "YYYY-MM-DD"
  childTypePrice: {
    childrenType10: number;
    childrenType15: number;
    childrenType20: number;
    childrenType30: number;
    childrenType40: number;
    childrenType50: number;
    visitorType10: number;
    visitorType15: number;
    visitorType20: number;
    visitorType30: number;
    visitorType40: number;
    visitorType50: number;
  };
  roomPrice: unknown;
  price: number;
  adultPrice: number;
  boneSubsidy: 0;
  stock: 100;
  reservationDiv: '50';
  childrenPriceTable: {
    childDiv: string;
    childPrice: number;
    price: number;
    boneSubsidy: 0;
  }[];
  memberAdultCnt: number;
  memberAdultPrice: number;
  memberAdultChrg: number;
  visitorAdultCnt: 0;
  visitorAdultPrice: 0;
  visitorAdultChrg: 0;
  memberChldCnt: ChildrenType;
  memberChldPrice: ChildrenType;
  memberChldChrg: ChildrenType;
  totalMemberChldCnt: number;
  totalMemberChldChrg: number;
  visitorChldCnt: ChildrenType;
  visitorChldPrice: ChildrenType;
  visitorChldChrg: ChildrenType;
  totalVisitorChldCnt: 0;
  totalVisitorChldChrg: 0;
}[];

export type VacancyCalendarType = {
  roomPrice: null;
  price: number;
  adultPrice: number;
  stayDay: string | undefined;
  boneSubsidy: number;
  childrenPriceTable: {
    childDiv: string;
    childPrice: number;
    price: number;
    boneSubsidy: number;
  }[];
  reservationDiv: string; // "50"
  stock: number;
};

export type StayRoomDetailType = {
  stayDays: StayDayType;
  member: {
    man: number;
    woman: number;
  };
  visitors: {
    man: number;
    woman: number;
  };
  memberChildren: ChildrenType;
  visitorChildren: ChildrenType;
  adultCount: number;
  childrenCount: number;
  roomAmount: number;
  roomNo: number;
  chldaManHeadCnt: number;
  chldaWomanHeadCnt: number;
  vacancyCalendar: {
    vacancyCalendars: VacancyCalendarType[];
  };
  relationships: {
    id: number;
    label: string;
    value: string;
    relationshipCode: string;
    relationship: {
      code: 'C';
      groupName: null;
      relationshipId: string; // "0"
      relationshipName: string;
      relationshipLevel: string; // "0"
      genderDistinction: null;
    };
    age: number | '';
    isMember: boolean;
    isChildren: boolean;
    chldType: 'childrenType10' | '';
    isVisitor: boolean;
  }[];
}[];

export type CouponMixinApplyCouponResponseType = {
  stayNightDetails: StayNightDetailType[];
  totalDiscountAmount: number;
  totalAppliedCouponPrice: number;
  totalForceUseDiscount: number;
  remainingSubsidys: SubsidyAvailableDataListType[];
};

export type CoupoonMixinManualApplyCouponResponseType = {
  stayNightDetails: StayNightDetailType[];
  totalDiscountAmount: number;
  totalAppliedCouponPrice: number;
  totalForceUseDiscount: number;
  remainingSubsidys: SubsidyAvailableDataListType[];
  isChangeUsePlan: boolean;
};

export type CouponApplyDateListType = {
  subsidyId: string;
  subsidyDetailId: string;
  relationship: string;
  degreeCount: string;
  age: number | null;
  firstName: string;
  lastName: string;
  ageType: string | null;
  priceType: string | null;
  useDates: {
    useScheduleDateTime: string;
    price: number | null;
    subsidyPriceId: string | null;
  }[];
  groupId: string | null;
  couponId: string;
};

// 補助クーポンの説明を取得
//* ***********************************************************************************/
const isShowParsonalUsedMaxCnt = (subsidy: SubsidyAvailableDataListType) =>
  subsidy.availableData.parsonalUsedMaxCnt > 0 && subsidy.availableData.parsonalUsedMaxTotalAmt > 0;
const isShowUsedMaxCntInsurance01 = (subsidy: SubsidyAvailableDataListType) => subsidy.availableData.parsonalUsedMaxCnt;
const isShowUsedMaxTotalAmt = (subsidy: SubsidyAvailableDataListType) => subsidy.availableData.parsonalUsedMaxTotalAmt || null;

const convertRemainingCountLabel = (src: string | null): string => {
  if (!src) return '';
  return src
    .split(',')
    .filter((item) => !item.includes('null'))
    .join(',');
};

export const getCouponDescription = (subsidy: SubsidyAvailableDataListType): string[] => {
  const couponDesc: string[] = [];

  // 利用制限期間[01:年]の場合
  if (subsidy.availableData.usedLimTerm === '01') {
    couponDesc.push('上記適用期間内での制限適用となります');
  }
  // 利用制限期間[02:月]の場合
  if (subsidy.availableData.usedLimTerm === '02') {
    couponDesc.push('月の利用制限となります');
  }

  if (subsidy.availableData.requestType === '01') {
    if (isShowParsonalUsedMaxCnt(subsidy)) {
      const mes = `保有枚数${subsidy.availableRemainingCount.toLocaleString()}/
          ${subsidy.availableData.parsonalUsedMaxCnt.toLocaleString()}
          枚（利用可能残額${subsidy.availableRemainingAmount.toLocaleString()}/
          ${subsidy.availableData.parsonalUsedMaxTotalAmt.toLocaleString()}
          円）までご利用いただけます。`;
      couponDesc.push(mes);
    }
    if (subsidy.availableData.parsonalUsedMaxCnt > 0 && !subsidy.availableData.parsonalUsedMaxTotalAmt) {
      const mes = `保有枚数${subsidy.availableRemainingCount.toLocaleString()}/
          ${subsidy.availableData.parsonalUsedMaxCnt.toLocaleString()}
          枚までご利用いただけます。`;
      couponDesc.push(mes);
    }
    if (!subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableData.parsonalUsedMaxTotalAmt > 0) {
      const mes = `利用可能残額${subsidy.availableRemainingAmount}/
          ${subsidy.availableData.parsonalUsedMaxTotalAmt.toLocaleString()}
          円までご利用いただけます。`;
      couponDesc.push(mes);
    }
  }

  // 健保補助金の場合
  if (subsidy.availableData.requestType === '02') {
    // 上限枚数が1枚以上設定されている場合
    if (isShowUsedMaxCntInsurance01(subsidy) > 0 && !isShowUsedMaxTotalAmt(subsidy)) {
      const mes = `${subsidy.availableData.applicableDegreeCnt}
          親等までを対象者として、1対象者あたり最大
          ${subsidy.availableData.parsonalUsedMaxCnt.toLocaleString()}
          枚までご利用いただけます。`;
      couponDesc.push(mes);
    }

    // 上限金額が1円以上設定されている場合
    if (isShowUsedMaxTotalAmt(subsidy) > 0 && !isShowUsedMaxCntInsurance01(subsidy)) {
      const mes = `${subsidy.availableData.applicableDegreeCnt}
          親等までを対象者として、1対象者あたり最大
          ${subsidy.availableData.parsonalUsedMaxTotalAmt.toLocaleString()}
          円までご利用いただけます。`;
      couponDesc.push(mes);
    }

    // 上限金額・上限枚数が1円・1枚以上設定されている場合
    if (isShowUsedMaxTotalAmt(subsidy) > 0 && isShowUsedMaxCntInsurance01(subsidy) > 0) {
      const mes = `第${subsidy.availableData.applicableDegreeCnt}
          親等までを対象者として、1対象者あたり最大
          ${subsidy.availableData.parsonalUsedMaxCnt.toLocaleString()}枚、
          ${subsidy.availableData.parsonalUsedMaxTotalAmt.toLocaleString()}
          円までご利用いただけます。`;
      couponDesc.push(mes);
    }

    // 上限金額が０円（使い切った）または存在しない場合（未設定）
    // かつ
    // 保有金額が1円以上設定されている場合
    if ((isShowUsedMaxTotalAmt(subsidy) === 0 || !isShowUsedMaxTotalAmt(subsidy)) && subsidy.availableRemainingAmount > 0) {
      const mes = `第${subsidy.availableData.applicableDegreeCnt}
          親等までを対象者として、1対象者あたり最大
          ${subsidy.availableRemainingAmount.toLocaleString()}
          円までご利用いただけます`;
      couponDesc.push(mes);
    }

    // 残金額
    if (subsidy.scrennDisplayItemList && subsidy.scrennDisplayItemList.remainingAmountLabel?.value) {
      const mes = `下記は、過去に利用した対象者の保有枚数（残金額）を表示しています。
          未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
          ${convertRemainingCountLabel(subsidy.scrennDisplayItemList.remainingAmountLabel.value)}`;
      couponDesc.push(mes);
    }

    // 残枚数
    if (subsidy.scrennDisplayItemList && subsidy.scrennDisplayItemList.remainingCountLabel?.value) {
      const mes = `下記は、過去に利用した対象者の保有枚数を表示しています。
          未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
          ${convertRemainingCountLabel(subsidy.scrennDisplayItemList.remainingCountLabel.value)}`;
      couponDesc.push(mes);
    }
  }

  // 利用上限総額（数）
  // usedLimUnit(利用制限単位)による条件分岐は不要。
  // usedLimUnitが01(個人)の場合は、usedMaxCnt・usedMaxTotalAmtはセットされない
  if (subsidy.availableData.usedMaxCnt) {
    couponDesc.push(`所属団体様内で先着${subsidy.availableData.usedMaxCnt}枚まで`);
  }
  if (subsidy.availableData.usedMaxTotalAmt) {
    couponDesc.push('※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。');
  }
  if (subsidy.availableData.minChargeAmt === 1) {
    couponDesc.push('必ず自己負担が必要になります。');
  }
  if (subsidy.availableData.minChargeAmt && subsidy.availableData.minChargeAmt > 1) {
    const mes = `${subsidy.availableData.minChargeAmt}
      円以上のご負担が必要となります。`;
    couponDesc.push(mes);
  }
  if (!subsidy.availableData.minChargeAmt && subsidy.availableData.costUnderChargeableFlg === '0') {
    couponDesc.push('利用金額が補助金額に満たない場合は利用不可');
  }
  if (subsidy.availableData.minTgtAge) {
    const mes = `${subsidy.availableData.minTgtAge}歳以上が対象`;
    couponDesc.push(mes);
  }
  if (subsidy.availableData.personAccompanyFlg === '1') {
    couponDesc.push('家族会員のみでの利用不可');
  }
  if (subsidy.availableData.multipleUnusableFlg === '0') {
    couponDesc.push('併用可');
  }
  if (subsidy.availableData.multipleUnusableFlg === '1') {
    couponDesc.push('併用不可');
  }
  if (subsidy.availableData.usedFormDiv === USED_FORM_DIV.FORCED) {
    couponDesc.push('対象メニューの申込で自動で利用できます。');
  }
  if (subsidy.availableData.usedFormDiv === USED_FORM_DIV.ANY) {
    couponDesc.push('利用申請があった場合のみ利用できます。');
  }

  return couponDesc;
};

// 補助クーポン枚数候補リストの生成
//* ***********************************************************************************/
const isSameAgeType = (source: PriceListItemType, target: PriceListItemType): boolean => {
  if (source.subsidyDetailId === target.subsidyDetailId && source.priceType === target.priceType) {
    return true;
  }

  if (
    source.subsidyDetailId === target.subsidyDetailId &&
    (source.priceType === COUPON_PRICE_TYPE.BOLT || target.priceType === COUPON_PRICE_TYPE.BOLT)
  ) {
    return true;
  }

  return false;
};

export const getSubsidyOptions = (
  day: StayNightDetailType,
  subsidy: SubsidyAvailableDataListType,
  price: PriceListItemType,
  totalMemberCount: number,
  stayNights: number,
  stayNightDetails: StayNightDetailType[]
): { label: string; value: number }[] => {
  let count = null;
  const remainingCount = subsidy.availableRemainingCount;

  // max selectable: peoples & nights
  const limitCnt = totalMemberCount * stayNights;
  if (subsidy.availableRemainingCount === null || (count !== null && count > limitCnt)) {
    count = limitCnt;
  }
  const thisSelectUseCnt = price.selectUseCnt || 0;

  // CHECK RELATIONSHIP
  const { applicableDegreeCnt } = subsidy.availableData;
  const { minTgtAge } = subsidy.availableData;

  if (subsidy.availableData.requestType === '01') {
    // DOANH NGHIỆP
    if (price.priceType === COUPON_PRICE_TYPE.OWNER) {
      // Chính chủ
      count = day.rooms
        .map((r) => {
          const ownCnt = r.relationships
            .filter(
              (rela) =>
                !rela.isVisitor &&
                rela.relationshipCode === 'C-0-0' &&
                // rela.relationshipCode !== 'C-205-9' && [ISOL_TODO] 不要なコードでTSエラーとなるためコメントアウト
                (!rela.isChildren || (rela.isChildren && (!minTgtAge || (minTgtAge && +rela.age >= +minTgtAge))))
            )
            .map(() => 1)
            .reduce((a, b) => a + b, 0);
          return ownCnt;
        })
        .reduce((a, b) => a + b, 0);
    } else if (price.priceType === COUPON_PRICE_TYPE.FAMILY) {
      // Gia đình
      count = day.rooms
        .map((r) => {
          const famalyCnt = r.relationships
            .filter(
              (rela) =>
                !rela.isVisitor &&
                rela.relationshipCode !== 'C-0-0' &&
                rela.relationshipCode !== 'C-205-9' &&
                (applicableDegreeCnt === null || +rela.relationship.relationshipLevel <= applicableDegreeCnt) &&
                (!rela.isChildren || (rela.isChildren && (!minTgtAge || (minTgtAge && +rela.age >= +minTgtAge))))
            )
            .map(() => 1)
            .reduce((a, b) => a + b, 0);
          return famalyCnt;
        })
        .reduce((a, b) => a + b, 0);
    } else {
      // Đồng giá
      count = day.rooms
        .map((r) => {
          const memberCnt = r.relationships
            .filter(
              (rela) =>
                !rela.isVisitor &&
                rela.relationshipCode !== 'C-205-9' &&
                (applicableDegreeCnt === null || +rela.relationship.relationshipLevel <= applicableDegreeCnt) &&
                (!rela.isChildren || (rela.isChildren && (!minTgtAge || (minTgtAge && +rela.age >= +minTgtAge))))
            )
            .map(() => 1)
            .reduce((a, b) => a + b, 0);
          return memberCnt;
        })
        .reduce((a, b) => a + b, 0);
    }
  } else {
    // BẢO HIỂM
    let x = 0;
    let found = false;
    day.rooms.forEach((room) => {
      room.relationships
        .filter((r) => r.relationshipCode === price.relationshipCode)
        .forEach((rel) => {
          const relationshipLevel = +rel.relationship.relationshipLevel;
          // CHÍNH CHỦ
          if (rel.relationship.relationshipId === '0') {
            let flg = false;
            // NGƯỜI LỚN
            if (!rel.isChildren && price.priceType === COUPON_PRICE_TYPE.OWNER && price.ageType === COUPON_AGE_TYPE.ADULT) {
              x += 1;
              flg = true;
              found = true;
            } else if (rel.isChildren && price.priceType === COUPON_PRICE_TYPE.OWNER && price.ageType === COUPON_AGE_TYPE.CHILDREN) {
              // TRẺ EM
              if (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge)) {
                x += 1;
              }
              flg = true;
              found = true;
            }
            if (!flg && price.priceType === COUPON_PRICE_TYPE.OWNER && price.ageType === COUPON_AGE_TYPE.BOLT) {
              // ĐỒNG GIÁ
              x += 1;
              found = true;
            }
          } else if (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt) {
            // GIA ĐÌNH
            let flg = false;
            // NGƯỜI LỚN
            if (!rel.isChildren && price.priceType === COUPON_PRICE_TYPE.FAMILY && price.ageType === COUPON_AGE_TYPE.ADULT) {
              x += 1;
              flg = true;
              found = true;
            } else if (rel.isChildren && price.priceType === COUPON_PRICE_TYPE.FAMILY && price.ageType === COUPON_AGE_TYPE.CHILDREN) {
              // TRẺ EM
              if (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge)) {
                x += 1;
              }
              flg = true;
              found = true;
            }
            if (!flg && price.priceType === COUPON_PRICE_TYPE.FAMILY && price.ageType === COUPON_AGE_TYPE.BOLT) {
              // ĐỒNG GIÁ
              x += 1;
              found = true;
            }
          }
          // ĐỒNG GIÁ
          if (
            !found &&
            !rel.isChildren &&
            price.priceType === COUPON_PRICE_TYPE.BOLT &&
            price.ageType === COUPON_AGE_TYPE.ADULT &&
            (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt)
          ) {
            x += 1;
          } else if (
            !found &&
            rel.isChildren &&
            price.priceType === COUPON_PRICE_TYPE.BOLT &&
            price.ageType === COUPON_AGE_TYPE.CHILDREN &&
            (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt) &&
            (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge))
          ) {
            x += 1;
          } else if (
            !found &&
            !rel.isChildren &&
            price.priceType === COUPON_PRICE_TYPE.BOLT &&
            price.ageType === COUPON_AGE_TYPE.BOLT &&
            (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt)
          ) {
            x += 1;
          } else if (
            !found &&
            rel.isChildren &&
            price.priceType === COUPON_PRICE_TYPE.BOLT &&
            price.ageType === COUPON_AGE_TYPE.BOLT &&
            (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt) &&
            (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge))
          ) {
            x += 1;
          }
        });
    });
    count = x;
  }

  // CHECK REMAINING
  if (remainingCount !== null && remainingCount < count) {
    count = remainingCount;
  }

  // MAX - SELECTED
  let selectedCnt = 0;
  stayNightDetails
    .filter((night) => night.stayDay === day.stayDay)
    .forEach((night) => {
      night.coupons.forEach((coupon) => {
        if (coupon.availableData.requestType === '01') {
          // DOANH NGHIỆP
          coupon.availableData.priceList.forEach((p) => {
            const isSame = isSameAgeType(price, p);
            if (isSame) {
              selectedCnt += +p.selectUseCnt;
            }
          });
        } else {
          coupon.availableData.priceList.forEach((p) => {
            if (p.subsidyPriceId === price.subsidyPriceId && p.relationshipCode === price.relationshipCode) {
              selectedCnt += +p.selectUseCnt;
            }
          });
        }
      });
    });

  if (selectedCnt) {
    count -= selectedCnt;
  }
  count += thisSelectUseCnt;

  const options = [];
  for (let i = 0; i <= count; i += 1) {
    options.push({
      label: String(i),
      value: i,
    });
  }

  return options;
};
